/* eslint-disable no-mixed-spaces-and-tabs */
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

//import OG from '../images/og-image.png';
import Touch from '../images/touch-icon.png';
import Favicon from '../images/favicon.ico';

const SEO = ({ slug, title, description, keywords, noindex, nofollow }) => {
	const pagePathSeparator = slug?.[0] === '/' ? '' : '/';
	let pagePath = [process.env.GATSBY_CONTENTFUL_BASE, slug].join(pagePathSeparator);
	if (!pagePath.endsWith('/')) pagePath = `${pagePath}/`;

	return (
		<>
			<Helmet
				title={
					title || 'Drive-Thru COVID-19 Testing Clinic Near Me | Covid Clinic'
				}
				meta={[
					{
						name: 'description',
						content:
							description ||
							'Covid Clinic provides several drive-thru testing sites with a variety of COVID testing options to help stop the spread of COVID-19. Book online today!',
					},
					{
						name: 'keywords',
						content:
							(keywords && keywords.join(', ')) ||
							'Covid, COVID-19, Covid Clinic, COVID-19 Tests, COVID-19 Testing',
					},
					{
						name: 'robots',
						content: `${nofollow ? 'nofollow' : 'follow'}, ${
							noindex ? 'noindex' : 'index'
						}, max-snippet:-1, max-video-preview:-1, max-image-preview:large`,
						// leaving compose implementation for posterity -- feel free to swap
						// content:
						// 	!nofollow && !noindex
						// 		? 'all'
						// 		: `${noindex ? 'noindex' : ''}${
						// 			nofollow ? ', nofollow' : ''
						// 		  }`,
					},
					{
						property: 'og:title',
						content:
							title ||
							'Drive-Thru COVID-19 Testing Clinic Near Me | Covid Clinic',
					},
					{
						property: 'og:site_name',
						content: 'Covid Clinic',
					},
					{
						property: 'og:url',
						content: pagePath,
					},
					{
						property: 'og:description',
						content:
							description ||
							'Covid Clinic provides several drive-thru testing sites with a variety of COVID testing options to help stop the spread of COVID-19. Book online today!',
					},
					{
						property: 'og:type',
						content: 'website',
					},
					{
						name: 'twitter:card',
						content: 'summary_large_image',
					},
					{
						name: 'twitter:creator',
						content: 'Covid Clinic',
					},
					{
						name: 'twitter:title',
						content:
							title ||
							'Drive-Thru COVID-19 Testing Clinic Near Me | Covid Clinic',
					},
					{
						name: 'twitter:description',
						content:
							description ||
							'Covid Clinic provides several drive-thru testing sites with a variety of COVID testing options to help stop the spread of COVID-19. Book online today!',
					},
				]}
			>
				<link rel="shortcut icon" type="image/x-icon" href={Favicon} />
				<link rel="apple-touch-icon" sizes="192x192" href={Touch} />
				<link rel="canonical" href={pagePath} />
			</Helmet>
			{/* Nextdoor Pixel */}
			<img
				src="https://protect-us.mimecast.com/s/NvSZCmZPwVHj60DXiNfKqb?domain=flask.nextdoor.com"
				height="1"
				width="1"
				className="hidden"
			/>
			{/* Zoom Pixel */}
			<img
				src="https://protect-us.mimecast.com/s/PrbhCo2PY9tr8oZ9C2K3ge?domain=ws.zoominfo.com"
				width="1"
				height="1"
				className="hidden"
			/>
			{/* Firstline Conversion Pixel */}
			<img
				src="https://protect-us.mimecast.com/s/3RLSCpYPg6TnylKkfvGf_u?domain=secure.adnxs.com"
				width="1"
				height="1"
				className="hidden"
			/>
			{/* Firstline Segment Pixel */}
			<img
				src="https://protect-us.mimecast.com/s/VdHNCqx9jXS8R4lBIYUomq?domain=secure.adnxs.com"
				width="1"
				height="1"
				className="hidden"
			/>
			{/* Adform Pixel */}
			<img
				src="https://protect-us.mimecast.com/s/NPReCv2kg7t74BK1HYWt-f?domain=a2.adform.net"
				width="1"
				height="1"
				className="hidden"
			/>
		</>
	);
};

export default SEO;

SEO.defaultProps = {
	title: 'Drive-Thru COVID-19 Testing Clinic Near Me | Covid Clinic',
	description:
		'Covid Clinic provides several drive-thru testing sites with a variety of COVID testing options to help stop the spread of COVID-19. Book online today!',
	keywords: ['Covid Clinic'],
	noindex: false,
	nofollow: false,
};

SEO.propTypes = {
	slug: PropTypes.string.isRequired,
	description: PropTypes.string,
	keywords: PropTypes.arrayOf(PropTypes.string),
	title: PropTypes.string.isRequired,
	noindex: PropTypes.bool,
	nofollow: PropTypes.bool,
};
